// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "content_editor_token".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "content_editor_token" table (1:1 with a DB row, on the wire). */
export const contentEditorTokenAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    itemId: z.string(),
    conversationId: z.string(),
    userId: z.string(),
    tokenHash: z.string(),
    reason: z.string(),
    consumedAt: z.string().datetime().nullable(),
    expiresAt: z.string().datetime(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=contentEditorToken.js.map